import React, { useEffect, useState } from "react";
import Edit from "../../../../../assets/img/Edit.png";
import Avatar from "../../../../../assets/svg/UserAvatarIcon.svg";
import styles from "../../../Introspekcije.module.css";

export default function CommentSection({
  isMentorRole,
  userData,
  mentorData,
  dbComment,
  showEditComment,
  handleInputChange,
  userId,
  setShowEditComment,
  introspectionData,
  comments,
  inputValue,
  minCommentSize,
  commentSize,
}) {
  const [imageSource, setImageSource] = useState("");
  useEffect(() => {
    setImageSource(
      isMentorRole ? userData?.imageUrl : mentorData?.imageUrl || Avatar
    );
  }, [isMentorRole, userData, mentorData]);

  return (
    <div className={styles.commentWrapper}>
      <div className={styles.commentRow}>
        <img alt="avatar" src={imageSource} className={styles.avatar} />
        <div className={styles.commentContainer}>
          <textarea
            value={inputValue}
            className={styles.textarea}
            autoFocus={showEditComment}
            disabled={!showEditComment}
            onChange={handleInputChange}
          />

          {isMentorRole &&
            (userId === "Voditelj" ||
              userId === "Polaznik VT-a" ||
              userId === "Terapeut" ||
              userId === "Učitelj" ||
              userId === "Supervizor") &&
            !showEditComment && (
              <button
                className={styles.editCommentBtn}
                onClick={() => setShowEditComment(true)}
              >
                <img alt="" src={Edit} />
              </button>
            )}
        </div>
      </div>
      {showEditComment && (
        <div
          className={styles.commentCharacters}
          style={{ width: "100%", textAlign: "right", fontSize: 15 }}
        >
          {commentSize}/{minCommentSize}
        </div>
      )}
    </div>
  );
}
